export const textES = {
  completeds: 'completos'
}
